export function polling(func: CallableFunction, timeout = 5000): () => void {
  const intervalID = setInterval(func, timeout)
  return () => clearInterval(intervalID)
}
